import { ethers } from 'ethers';
import FixedTermsTokenEscrowFactoryAbi from './FixedTermsTokenEscrowFactory.abi.json';

const ABI = FixedTermsTokenEscrowFactoryAbi as ethers.InterfaceAbi;

export function getFactoryContract(
  signer: ethers.Signer,
  factoryAddress: string
): ethers.Contract {
  return new ethers.Contract(factoryAddress, ABI, signer);
}

export interface DeployEscrowParams {
  tokenA: string;
  tokenB: string;
  amountA: bigint;
  amountB: bigint;
  deadline: number; // unix timestamp (seconds)
  trustlineValidationEngineLogic: string;
  trustlineValidationEngineProxy: string;
}

export interface DeployEscrowResult {
  hash: string;
  escrowAddress: string;
}

export async function deployEscrow(
  signer: ethers.Signer,
  factoryAddress: string,
  params: DeployEscrowParams
): Promise<DeployEscrowResult> {
  const contract = getFactoryContract(signer, factoryAddress);
  const tx = await contract.deployEscrow(
    params.tokenA,
    params.tokenB,
    params.amountA,
    params.amountB,
    params.deadline,
    params.trustlineValidationEngineLogic,
    params.trustlineValidationEngineProxy
  );
  const receipt = await tx.wait();
  if (!receipt) throw new Error('Transaction failed');
  const iface = contract.interface;
  const log = receipt.logs.find(
    (l: { address: string }) => l.address.toLowerCase() === factoryAddress.toLowerCase()
  );
  if (!log) throw new Error('EscrowDeployed event not found');
  const parsed = iface.parseLog({ topics: log.topics as string[], data: log.data });
  if (!parsed || parsed.name !== 'EscrowDeployed') throw new Error('EscrowDeployed event not found');
  const escrowAddress = parsed.args[0] as string;
  return { hash: receipt.hash, escrowAddress };
}
